<template>
  <div>
    <TopMenu></TopMenu>
    <div class="contentBox">
      <div class="logo">
        <img v-if="imageUrl" :src="imageUrl" alt />
        <img v-else src="@/assets/defaultCompany.png" alt />
      </div>
      <div style="margin-top: 20px; width:100%">
        <span class="bigTitle">{{Companyname}}</span>
        <i class="el-icon-edit-outline bigIcon" @click="editInfo = true" v-if="$_has('c-edit')"></i>
        <br />
        <el-input type="textarea" autosize readonly v-model="introduction" class="elInput"></el-input>
      </div>
    </div>
    <dialog-panel
      :title="'编辑公司信息'"
      :dialogController="editInfo"
      :width="'40%'"
      @cancel="editInfo = false"
      :showCancel="false"
      :showConfirm="false"
    >
      <el-form label-width="80px" :model="formLabelAlign" @submit.native.prevent="sureEdit">
        <el-form-item label="公司名称">
          <el-input v-model="formLabelAlign.name"></el-input>
        </el-form-item>
        <el-form-item label="公司logo">
          <el-upload
            class="avatar-uploader"
            :action="UploadUrl + 'api/file/upload'"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :headers="uploadHeaders"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="formLabelAlign.logo" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span style="margin-left: 10px; display: flex; color: #C0C4CC" >128 × 128</span>
        </el-form-item>
        <el-form-item label="公司简介">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8}"
            v-model="formLabelAlign.introduction"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="dialogBottom">
        <el-button type="primary" size="small" @click="sureEdit" v-preventReClick>确认</el-button>
        <!-- <el-button size="small" @click="formLabelAlign = {}">重置</el-button> -->
      </div>
    </dialog-panel>
  </div>
</template>

<script>
import { updateCompany, getCompanyDetail, getCompany } from './systemAPI'
import TopMenu from "./topMenu"
export default {
  data () {
    return {
      editInfo: false,
      formLabelAlign: {},
      fileList: [],
      Companyname: '',
      introduction: '',
      imageUrl: '',
      uploadHeaders: {
        jwtToken: localStorage.getItem('jwtToken')
      },
    }
  },
  methods: {
    sureEdit () {
      this.editInfo = false
      updateCompany(this.formLabelAlign).then(res => {
        if (res.code === 1000) {
          this.$message.success(`修改成功`);
          this.funGetCompanyDetail()
        }
      })
    },
    funGetCompanyDetail () {
      getCompany().then(res => {
        this.formLabelAlign = res.data
        this.Companyname = res.data.name
        this.introduction = res.data.introduction || '这个公司很懒，没有留下什么哦!'
        this.imageUrl = res.data.fileInfoVO?res.data.fileInfoVO.path:null
      })
    },
    fileRemove () {
      this.form.resumeAttachment = ''
      this.form.resumeAttachmentName = ''
    },
    handlePreview (file) {

    },
    handleAvatarSuccess (res, file) {
      this.imageUrl = res.data.path
      this.formLabelAlign.logo = res.data.key;// URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      // return isJPG && isLt2M;
      return isLt2M
    }
  },
  mounted () {
    this.funGetCompanyDetail()
  },
  components: {
    TopMenu
  }
}
</script>



<style scoped>
.elInput{
  max-width: 900px;
}
.elInput >>> textarea {
  margin-top: 20px;
  outline: none;
  /* overflow: auto; */
  /* height: auto; */
  /* border: none; */
  /* border: 0 none; */
  border: 1px solid #fff !important;
  padding: 0;
  resize: none;
}
.contentBox {
  display: flex;
  padding: 10px 20px;
}

.logo {
  width: 150px;
  height: 150px;
  margin-right: 40px;
  flex-shrink: 0; /*防止被压缩*/
}

.logo img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: fill;
}

.bigTitle {
  font-weight: bold;
}

.bigIcon {
  margin-left: 20px;
  font-weight: bold;
  font-size: 22px;
  cursor: pointer;
}

.dialogBottom {
  text-align: center;
  margin-top: 20px;
}

.avatar-uploader .avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .avatar-uploader-icon:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.show-text {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/system-manage/companyInfo.vue